import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { photosStore } from "../../../../stores/posts/usePhotosStore";
import Box from "@mui/material/Box";
import { Image } from "../../../custom/images/Image";
const width = 290 - 6;
const height = 180 - 4;
export const GalleryCard = ({ post }) => {
    photosStore.usePhotos();
    const photos = photosStore.getPhotosById(post.id);
    if (!photos)
        return _jsx(_Fragment, {}, void 0);
    return (_jsx(Box, { sx: {
            position: 'relative',
            right: '0px',
            transition: '250ms all',
            width: `${width}px`,
            height: `${height}px`,
            '&:hover': {
                transform: 'scale(1.2)',
                zIndex: 10,
            }
        }, children: _jsx(Image, { maxWidth: width, maxHeight: height, src: photos.find(p => p.phototype === 'preview')?.url || photos[0].url, alt: post.title, onClick: () => photosStore.openImageFullViewUrl({ photos, index: 0 }) }, void 0) }, void 0));
};
//# sourceMappingURL=GalleryCard.js.map